// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1ZkKi","description":"PatientConsentPreview_description__8765g"};